@import (reference) '../../constants/spacing.module.less';

.ups-terms-container {
  border: 1px solid var(--gray-E4E5E7);
  border-radius: @space-8;
  padding: @space-16;
  background-color: var(--gray-F9FAFB);
}

.ups-terms-checkbox {
  height: auto;
  font-size: 14px;
  line-height: 24px;
}

.ups-terms-text {
  line-height: 20px;
}

.terms-link {
  color: var(--blue-600);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.external-link-icon {
  width: 12px;
  margin-left: @space-4;
  fill: var(--blue-600);
}
